function CustomPagination({ currentPage, lastPage, onPageChange }) {
  if (lastPage <= 1) return null;

  const getPageNumbers = () => {
  const pages = [];
  const delta = 2; // show 2 pages before/after current

  let start = Math.max(1, currentPage - delta);
  let end = Math.min(lastPage, currentPage + delta);

  // Always show first page
  if (start > 1) {
    pages.push(1);
    if (start > 2) pages.push("...");
  }

  // Pages between start and end
  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  // Always show last page
  if (end < lastPage) {
    if (end < lastPage - 1) pages.push("...");
    pages.push(lastPage);
  }

  return pages;
};


  const pages = getPageNumbers();

  return (
    <div className="pagination text-center mt-4">
      {/* Prev Button */}
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="btnnss mx-1"
      >
        « Prev
      </button>

      {/* Page Numbers */}
      {pages.map((page, index) =>
        page === "..." ? (
          <span key={index} className="px-2">
            ...
          </span>
        ) : (
          <button
            key={page}
            className={`btnnss mx-1 ${page === currentPage ? "active" : ""}`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        )
      )}

      {/* Next Button */}
      <button
        disabled={currentPage === lastPage}
        onClick={() => onPageChange(currentPage + 1)}
        className="btnnss mx-1"
      >
        Next »
      </button>
    </div>
  );
}

export default CustomPagination;
